"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Icon_1 = (0, tslib_1.__importDefault)(require("../Icon"));
const S = (0, tslib_1.__importStar)(require("./styles"));
const Tag = (_a) => {
    var _b;
    var { label = '', iconPosition = 'right', showIcon = false, colorOption = 'black' } = _a, props = (0, tslib_1.__rest)(_a, ["label", "iconPosition", "showIcon", "colorOption"]);
    return ((0, jsx_runtime_1.jsxs)(S.StyledTag, Object.assign({ "data-testid": "button", colorOption: colorOption, showIcon: showIcon, iconPosition: iconPosition, label: label }, props, { children: [showIcon && ((0, jsx_runtime_1.jsx)(Icon_1.default, { icon: "Close", color: (_b = S.buttons[colorOption]) === null || _b === void 0 ? void 0 : _b.iconColor, size: 16 }, void 0)), (0, jsx_runtime_1.jsx)(S.StyledLabel, { children: label }, void 0)] }), void 0));
};
exports.default = Tag;
